import axios from 'axios';
import React, { useEffect, useState } from 'react';
import CryptoJS from 'crypto-js';
import { CallAPIPromise } from '../utility/func/func';

const ActivationAccount = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const userEmail = searchParams.get('user_email');
  const activationCode = searchParams.get('activate_code');
  const [userStatus, setuserStatus] = useState('In progress');
  const secretPass = process.env.REACT_APP_AUTH_SECRET_KEY;

  // const hmac = CryptoJS.HmacSHA256(message, secret);
  const hmac = CryptoJS.HmacSHA256(userEmail, secretPass);
  // Convert the HMAC to a string and encode it using Base64
  const hmacString = hmac.toString(CryptoJS.enc.Base64);

  const ActivateUser = () => {
    CallAPIPromise(
      `/api/usersRoute/userInfo`,
      {
        user_email: userEmail,
      },
      hmacString
    )
      .then(async function (response) {
        if (response.data.response[0]) {
          CallAPIPromise(
            '/api/companyRegistration/activateUser',
            {
              user_email: userEmail,
              activate_code: activationCode,
              user_name: response.data.response[0].user_name,
              CODE: response.data.response[0].code,
              table_prefix: response.data.response[0].table_prefix,
              table_prefix_master: response.data.response[0].table_prefix,
            },
            hmacString
          )
            .then((d) => {
              setuserStatus('Activated');
              console.log('activated');
            })
            .catch((err) => {
              console.log(err);
            });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    if (activationCode) {
      ActivateUser();
    }
  }, []);
  return (
    <div className="h-screen w-screen p-4">Account status : {userStatus}</div>
  );
};

export default ActivationAccount;
